<template><div><div v-if="options_loaded && passed_filter && options_filter">
    <div class="form-group" :class="[!valid_selection ? 'has-error' : '']">
        <label :for="'question--' + component_id">{{ title }}</label>
        <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
            <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
        </select>
        <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
            <option>Loading Options...</option>
        </select>
    </div>
</div></div></template>


<script type="text/ecmascript-6">
import DesignerQuestionHardwareSpyHolePosition from "../DesignerQuestionHardwareSpyHolePosition.vue";
    import SynsealQuestion from "../mixin/synseal/Question.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareSpyHolePosition,
            SynsealQuestion
        ],
    }
</script>
